import type { ApiListingApplicationListingType } from 'api/types/ApiListingApplicationListingType';
import type { ApiOrgId } from 'api/types/ApiTypedId';
import type { ApiOrgType } from 'modules/listing/orgs/api/types/ApiOrgType';
import { trackEvent } from 'utils/analytics/track/trackEvent';

type Args = {
  listingId: string;
  listingType: ApiListingApplicationListingType;
  orgId: ApiOrgId | null;
  orgType: ApiOrgType | null;
  isNewResume: boolean;
  hasAts: boolean;
};

export function trackAppliedToListing({
  listingId,
  listingType,
  orgId,
  orgType,
  isNewResume,
  hasAts,
}: Args) {
  trackEvent('Success: Applied to Listing', {
    listing_id: listingId,
    listing_type: listingType,
    org_id: orgId,
    org_type: orgType,
    is_new_resume: isNewResume,
    has_ats: hasAts,
  });
}
